var React = require('react');

function Person (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#7D858E"},React.createElement("g",{"transform":"translate(-854 -3198) translate(854 3198)"},[React.createElement("path",{"d":"M11.22 7.325C11.22 10.442 9.35 12 5.61 12S0 10.442 0 7.325h11.22z","transform":"matrix(1 0 0 -1 0 19.325)","key":0}),React.createElement("circle",{"cx":"5.61","cy":"2.805","r":"2.805","key":1})]))));
}

Person.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Person;

Person.default = Person;
